import Footer from "./parts/footer"
import HeaderInternal from "./parts/header-internal"
import QuestionnaireForm from "./forms/questionnaire";
import { useState } from "react";

function Сongratulation() {
    const [copied, setCopied] = useState(false);

    const handleCopyManager = () => {
        navigator.clipboard.writeText("@witmanagerua");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <>
            <HeaderInternal />
            <div className="container w-full max-w-screen-sm m-auto my-16 mb-4 py-10">
                <h1 className="text-3xl mb-6">Дякуємо за реєстрацію!</h1>
                <p className="mb-3">Вітаємо з успішною реєстрацією на безоплатну освітню програму <b>Women in Tech 2026!</b></p>
                <p className="mb-3">👉 Обов’язково приєднуйся до Telegram-каналу програми: <a href="https://t.me/+HNYBA-osdtVhMDYy" className="cursor-pointer text-blue-600 hover:underline font-semibold" target="_blank" rel="noopener noreferrer">https://t.me/+HNYBA-osdtVhMDYy</a></p>
                <p className="mb-3">Тут ми публікуватимемо важливі анонси, розклад занять, організаційні повідомлення та посилання на онлайн-активності.</p>
                <p className="mb-3"><b>Шукай посилання на вебінари та інші онлайн-активності на email, який ти вказала під час реєстрації, а також в Telegram-каналі.</b></p>
                <p className="mb-3">Якщо виникнуть запитання щодо програми, тем чи спікерів, пиши нашій менеджерці в Telegram: <span onClick={handleCopyManager} className="cursor-pointer text-blue-600 hover:underline font-semibold" title="Клікни, щоб скопіювати">@witmanagerua</span>{copied && <span className="ml-2 text-green-600 text-sm">✓ Скопійовано!</span>}.</p>
                <p>До зустрічі на <b>Women in Tech 2026!</b></p>

            </div>
            {/*<div className="bg-[#AF00A9]/10 py-10">*/}
            {/*    <div className="container w-full max-w-screen-sm m-auto mb-4">*/}
            {/*        <QuestionnaireForm/>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <Footer/>
            </>

            )
            }

            export default Сongratulation;